import appConfig from 'config';
import * as Sentry from '@sentry/react';

const initSentry = () => {
  try {
    Sentry.init({
      dsn: appConfig.SENTRY_DSN,
      environment: appConfig.ENVIRONMENT,
      ignoreErrors: ['Non-Error promise rejection captured'],
    });
  } catch (err) {
    console.error('[sentry::initSentry failed]:', err);
  }
};

const captureError = async (error) => {
  try {
    console.error(error);
    Sentry.captureException(error);
  } catch (err) {
    console.log('[sentry::captureError failed]:', err);
  }
};

const captureCatalogError = ({
  e,
  error_type = null,
  step_name = null,
  action_name = null,
  extras = null,
}) => {
  try {
    console.error(e);
    Sentry.withScope(function (scope) {
      if (!!error_type) scope.setTag('error_type', error_type);
      if (!!step_name) scope.setTag('step_name', step_name);
      if (!!action_name) scope.setTag('action_name', action_name);
      if (!!extras) scope.setExtras(extras);
      Sentry.captureException(e);
    });
  } catch (err) {
    console.log('[sentry::captureCatalogError failed]:', err);
  }
};

const setUserContext = async (user) => {
  try {
    Sentry.configureScope((scope) => {
      scope.setUser(user);
    });
  } catch (err) {
    console.log('[sentry::setUserContext failed]:', err);
  }
};

const sendMessage = async (message, extra) => {
  try {
    if (extra) {
      return Sentry.withScope((scope) => {
        scope.setExtras(extra);
        Sentry.captureMessage(message);
      });
    }

    Sentry.captureMessage(message);
  } catch (err) {
    console.log('[sentry::sendMessage failed]:', err);
  }
};

export {
  initSentry,
  captureError,
  captureCatalogError,
  setUserContext,
  sendMessage,
};
